import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Play, X } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

export const Teaser = () => {
    const [open, setOpen] = useState(false);

    return (
        <section id="teaser" data-testid="teaser-section" className="relative border-y border-white/10 bg-[#070c18]/70 py-24 sm:py-32">
            <div className="mx-auto max-w-[1500px] px-5 sm:px-8">
                <Reveal className="mb-12 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
                    <div>
                        <Eyebrow>Proof of Concept</Eyebrow>
                        <h2 className="deck-heading font-display text-5xl sm:text-6xl tracking-[0.14em]">
                            THE PITCH <span>TEASER</span>
                        </h2>
                    </div>
                    <p className="font-mono text-[10px] tracking-[0.3em] text-zinc-500">
                        CONFIDENTIAL — INDUSTRY PREVIEW ONLY
                    </p>
                </Reveal>

                <Reveal delay={0.1}>
                    <button
                        data-testid="teaser-play-button"
                        onClick={() => setOpen(true)}
                        className="group relative block w-full overflow-hidden border border-white/10 text-left"
                        aria-label="Play the Deadly Ambition pitch teaser"
                    >
                        <div className="relative aspect-video w-full overflow-hidden">
                            <img
                                src="/videos/teaser-poster.jpg"
                                alt="Frame from the Deadly Ambition pitch teaser"
                                className="h-full w-full object-cover transition-transform duration-[1.6s] ease-out group-hover:scale-105"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-[#04060d]/90 via-transparent to-[#04060d]/40" />
                            <div className="absolute inset-0 bg-[#d6c68e]/0 transition-colors duration-500 group-hover:bg-[#d6c68e]/10" />
                        </div>

                        <div className="absolute inset-0 flex items-center justify-center">
                            <span className="flex h-20 w-20 sm:h-24 sm:w-24 items-center justify-center rounded-full border border-white/40 bg-black/40 backdrop-blur-md transition-all duration-500 group-hover:scale-110 group-hover:border-[#d6c68e] group-hover:bg-[#d6c68e] group-hover:shadow-[0_0_50px_rgba(214,198,142,0.6)]">
                                <Play size={26} className="ml-1 fill-white text-white" />
                            </span>
                        </div>

                        <div className="absolute bottom-0 inset-x-0 flex items-center justify-between px-5 sm:px-8 py-5">
                            <span className="font-mono text-[10px] sm:text-[11px] tracking-[0.3em] text-zinc-300">
                                DEADLY AMBITION — OFFICIAL PITCH TEASER
                            </span>
                            <span className="border border-white/20 bg-black/50 px-3 py-1 font-mono text-[10px] tracking-[0.2em] text-zinc-300">
                                01:22
                            </span>
                        </div>
                    </button>
                </Reveal>
            </div>

            <AnimatePresence>
                {open && (
                    <motion.div
                        data-testid="teaser-video-modal"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.35 }}
                        className="fixed inset-0 z-[100] flex items-center justify-center bg-black/95 p-4 sm:p-10"
                        onClick={() => setOpen(false)}
                    >
                        <button
                            data-testid="teaser-close-button"
                            aria-label="Close teaser"
                            onClick={() => setOpen(false)}
                            className="absolute top-5 right-5 z-10 flex h-11 w-11 items-center justify-center border border-white/25 text-white transition-colors hover:border-[#d6c68e] hover:text-[#d6c68e]"
                        >
                            <X size={20} />
                        </button>
                        <motion.div
                            initial={{ scale: 0.94, opacity: 0 }}
                            animate={{ scale: 1, opacity: 1 }}
                            exit={{ scale: 0.96, opacity: 0 }}
                            transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
                            className="w-full max-w-5xl"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <video
                                data-testid="teaser-video"
                                src="/videos/pitch-teaser.mp4"
                                poster="/videos/teaser-poster.jpg"
                                controls
                                autoPlay
                                playsInline
                                className="aspect-video w-full border border-white/15 bg-black"
                            />
                            <p className="mt-4 text-center font-mono text-[10px] tracking-[0.3em] text-zinc-500">
                                DEADLY AMBITION — PITCH TEASER · CELESTIAL LIGHT STUDIOS
                            </p>
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>
        </section>
    );
};
